import React, { useState, useEffect } from "react";
import { ReviewStarsProps } from "src/types/review-stars-props";
import { useTranslation } from "react-i18next";
import { icons } from "src/statics/icons";
import './review-stars.component.scoped.sass';

export const ReviewStarsComponent = (props: ReviewStarsProps) => {
  const { count, withText, total } = props;
  const [countDeciamal, setCountDeciamal] = useState(0);
  const emtyArr: any[] = [];
  const [emptyStars, setEmptyStars] = useState(emtyArr);
  const [filledStars, setFilledStars] = useState(emtyArr);
  const [withHalf, setWithHalf] = useState(false);
  const [t] = useTranslation();
  const { starHalfIco, starFilledIco, starEmptyIco } = icons;

  useEffect(() => {
    setCountDeciamal(Math.round(count * 10) / 10);
    starsCalculator(count);
    // eslint-disable-next-line
  }, [count])

  const starsCalculator = (count: number): void => {
    const numberOnly = Math.trunc(count);
    const decimalOnly = count - numberOnly;
    const withHalf = Boolean(decimalOnly);
    setWithHalf(withHalf);
    const filledCount = numberOnly > 5
      ? 5
      : numberOnly < 0
      ? 0
      : numberOnly;
    let emptyCount = 5 - filledCount - (withHalf ? 1 : 0);
    emptyCount = emptyCount > 5
      ? 5
      : emptyCount < 0
      ? 0
      : emptyCount;

    const emptyArr: string[] = new Array(emptyCount).fill('star');
    setEmptyStars(emptyArr);

    const filledArr: string[] = new Array(filledCount).fill('star');
    setFilledStars(filledArr);
  }
  return (
    <div className="review-stars">
      <div className="stars">
        {filledStars.map((item, index) => <img alt="star" key={index} src={starFilledIco} height="30px" width="30px"/>)}
        {withHalf && <img alt="star" src={starHalfIco} height="30px" width="30px"/>}
        {emptyStars.map((item, index) => <img alt="star" key={index} src={starEmptyIco} height="30px" width="30px"/>)}
      </div>
      {withText && <div className="info">
        <span className="main">
          {countDeciamal} {t('of')} {total}
        </span>
        <span className="total">
          {total} {t('reviews')}
        </span>
      </div>}
    </div>
  );
};
